import { api } from '../../../lib/api'

export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILED = 'GET_PRODUCTS_FAILED';

export const SEARCH_PRODUCTS_DASHBOARD = 'SEARCH_PRODUCTS_DASHBOARD';

export const PRODUCTS_CONVERSIONS_BEFORE = 'PRODUCTS_CONVERSIONS_BEFORE';

export const getProducts = function () {
  return function (dispatch) {
    dispatch({
      type: GET_PRODUCTS_REQUEST
    })
    api.getProducts().then(getProductsResponse => {
      dispatch({
        type: GET_PRODUCTS_SUCCESS,
        payload: getProductsResponse
      })
    }).catch(error => {
      dispatch({
        type: GET_PRODUCTS_FAILED,
        error
      })
    })
  }
}

export const searchProducts = (text) => {
  return (dispatch) => {
    dispatch({
      type: SEARCH_PRODUCTS_DASHBOARD,
      payload: text
    })
  }
}


export const setConversionsBefore = (value) => {
  return (dispatch) => {
    dispatch({
      type: PRODUCTS_CONVERSIONS_BEFORE,
      payload: value
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/get-products.js